import { render, staticRenderFns } from "./ModelPickerPopover.vue?vue&type=template&id=1ddc66d6"
import script from "./ModelPickerPopover.vue?vue&type=script&lang=js"
export * from "./ModelPickerPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports